import { SystemStyleObject } from "@chakra-ui/react";

export const defaultDateInputWrapperCss: SystemStyleObject = {
  width: "100%",

  "& .react-datepicker__input-container .react-datepicker__calendar-icon": {
    padding: "0",
    top: "50%",
    transform: "translateY(-50%)",
    left: "16px",
  },

  "& .react-datepicker__input-container input": {
    height: "36px",
    border: "1px solid #D0D5DD",
    borderRadius: "5px",
    padding: "8px 16px 8px 40px",
    width: "100%",
  },

  "& .react-datepicker__input-container input::placeholder": {
    fontSize: "14px",
    color: "#667085",
    lineHeight: "20px",
  },

  "& .react-datepicker__input-container input:focus": {
    outlineColor: "#00535C",
  },
};
